import { useMemo } from 'react'
import { equals } from 'ramda'

import { useFilterStore } from './store'
import { FilterValues, LoadingState, OptionsSlice } from './store/types'
import { calculateVisibility } from './visibilityRules'
export { filterActions } from './actions'

// BY ITEM

export const useFilter = <K extends keyof FilterValues>(key: K) => {
  const draft = useFilterStore((state) => state.draft[key])
  const def = useFilterStore((state) => state.defaults[key])
  return {
    draft,
    default: def,
  }
}

// OPTIONS

export const useFilterOptions = <K extends keyof OptionsSlice['options']>(key: K) => {
  const options = useFilterStore((state) => state.options[key])
  return options
}

// LOADING

export const useFilterOptionsLoading = () => {
  const loading = useFilterStore((state) => state.loading)
  return loading
}

export const useFilterOptionsLoadingByKey = (key: keyof LoadingState) => {
  const loading = useFilterStore((state) => state.loading[key])
  return loading
}

// READY

export const useFilterReady = () => {
  const ready = useFilterStore((state) => state.options.ready)
  return ready
}

// DIRTY

export const useFilterDirty = () => {
  const draft = useFilterStore((state) => state.draft)
  const applied = useFilterStore((state) => state.applied)
  const isDirty = useMemo(() => {
    return !equals(draft, applied)
  }, [draft, applied])
  return isDirty
}

// APPLIED

export const useFilterApplied = () => {
  const applied = useFilterStore((state) => state.applied)
  return applied
}

// DRAFT

export const useFilterDraft = () => {
  const draft = useFilterStore((state) => state.draft)
  return draft
}

// DEFAULT STATE

export const useFilterIsDefault = () => {
  const defaults = useFilterStore((state) => state.defaults)
  const applied = useFilterStore((state) => state.applied)
  const isDefault = useMemo(() => {
    return equals(defaults, applied)
  }, [defaults, applied])
  return isDefault
}

// VISIBILITY & ACTIVITY

export function useFilterVisibility() {
  const draft = useFilterStore((state) => state.draft)
  const options = useFilterStore((state) => state.options)
  const res = useMemo(() => calculateVisibility({ ...draft, ...options }), [draft, options])
  return res
}

// activity each filter item by filter id
export function useFilterActivity() {
  const applied = useFilterStore((state) => state.applied)
  const options = useFilterStore((state) => state.options)
  const res = useMemo(() => calculateVisibility({ ...applied, ...options }), [applied, options])
  return res
}
